module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-eddie-big-c9c7107c97f00be66dbaf1acdaea2430.svg";